module.exports = __webpack_public_path__ + "static/media/How to update employer client file accreditation status and generate reports.1337d076.png";